<template>
  <v-container grid-list-xl>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-flex v-for="portfolio in portfolios" :key="portfolio.src" xs12 sm12 md4 lg4 xl4>
        <v-card
          :href="portfolio.url"
          hover
          flat
          color="transparent"
          target="_blank"
          height="230"
        >
          <v-card-title></v-card-title>
          <v-img :src="portfolio.src" height="130" contain></v-img>
          <v-card-title primary-title class="justify-center">
            <v-flex text-xs-center subheading font-weight-bold>{{portfolio.title}}</v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: "SungheeWoo",
    titleTemplate: "%s-Publications",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Publications"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Sugnhee' Space" },
      { property: "og:site_name", content: "Sugnhee' Space" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://Sugnhee.space" },
      {
        property: "og:image",
        content: "https://i.imgur.com/Dcz2PGx.jpg"
      },
      {
        property: "og:description",
        content:
          "Publications"
      }
    ]
  },
  data() {
    return {
      portfolios: [
        {
          src: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/icon_patent.png",
          title: "SUNGHEE WOO and DONGJIN PARK - US Patent",
          url: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/resume/US_PATENT_SWOO_2022-12-05_Drawings.pdf"
        },

        {
          src: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/logo_jpr.png",
          title: "Woo et. al. (2013) - J. Proteome Research",
          url: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/resume/paper_woo2013.pdf"
        },

        {
          src: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/logo_proteomics.png",
          title: "Woo et. al. (2014) - PROTEOMICS",
          url: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/resume/paper_woo2014.pdf"
        },
        
        {
          src: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/logo_jpr.png",
          title: "Woo et. al. (2015) - J. Proteome Research",
          url: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/resume/paper_woo2015.pdf"
        },

        {
          src: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/img/logo_cell.png",
          title: "Zhang et. al. (2016) - Cell",
          url: "https://s3.us-west-1.amazonaws.com/sungheewoo.com/resume/paper_cell.pdf"
        },
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
</style>